import { EditorState, ContentBlock, genKey, SelectionState } from 'draft-js';

/**
 * @param {EditorState} editorState
 */
export function ensureHasBlock(editorState) {
	let content = editorState.getCurrentContent();
	if (!content.getFirstBlock()) {
		const newBlockKey = genKey();
		const newBlock = new ContentBlock({
			key: newBlockKey,
			type: 'unstyled',
			text: '',
		});
		content = content.set('blockMap', content.getBlockMap().set(newBlockKey, newBlock));
		const selection = SelectionState.createEmpty(newBlockKey);
		return EditorState.moveSelectionToEnd(
			EditorState.set(editorState, { currentContent: content, selection })
		);
	}
	return editorState;
}


// WEBPACK FOOTER //
// ./lib/helpers/ensureHasBlock.js